import { render, staticRenderFns } from "./DOMItem.vue?vue&type=template&id=30a124d4&"
import script from "./DOMItem.vue?vue&type=script&lang=js&"
export * from "./DOMItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports